<script setup lang="ts">
import { ref } from 'vue'
import Convert from './components/Convert.vue'
import Synthesis from './components/Synthesis.vue'
import DivineArms from './components/DivineArms.vue'
import FooterBar from '@/components/footer-bar/FooterBar.vue'

const curTab = ref('convert')
</script>

<template>
  <div class="institute-page page">
    <h2>研究所</h2>
    <el-tabs v-model="curTab" stretch>
      <el-tab-pane label="转换" name="convert" class="pane" lazy>
        <Convert class="pane-item" />
      </el-tab-pane>
      <el-tab-pane label="合成" name="synthesis" class="pane" lazy>
        <Synthesis class="pane-item" />
      </el-tab-pane>
      <el-tab-pane label="神兵" name="divineArms" class="pane" lazy>
        <DivineArms class="pane-item" />
      </el-tab-pane>
    </el-tabs>

    <FooterBar />
  </div>
</template>

<style lang="scss" scoped>
.institute-page {
  padding-top: 0;
  display: flex;
  flex-flow: column nowrap;
  height: 100%;
  overflow: hidden;
  .el-tabs {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-flow: column nowrap;
    :deep() {
      .el-tabs__content {
        flex: 1;
        .pane {
          height: 100%;
          .pane-item {
            height: 100%;
            overflow: hidden;
            display: flex;
          }
        }
      }
    }
  }
}
</style>
